/**
 * Build table of contents from article headings (h2, h3)
 * Highlights active section on scroll
 */
function slugifyHeading(text) {
    return text
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
}

export default function tableOfContents() {
    const article = document.querySelector('.gh-article .gh-content');
    const tocList = document.getElementById('gh-toc-list');
    const tocAside = document.querySelector('.gh-toc');

    if (!article || !tocList || !tocAside) return;

    const headings = [...article.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
    if (headings.length === 0) {
        tocAside.style.display = 'none';
        return;
    }

    const usedIds = new Set();
    const tocLinks = [];
    const fragment = document.createDocumentFragment();

    headings.forEach((heading, index) => {
        let base = (heading.id && heading.id.trim()) || slugifyHeading(heading.textContent);
        if (!base) base = `section-${index}`;

        let id = base;
        let n = 1;
        while (usedIds.has(id)) {
            id = `${base}-${n++}`;
        }
        usedIds.add(id);
        heading.id = id;

        const level = heading.tagName.toLowerCase();
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent;
        link.className = `gh-toc-link gh-toc-link-${level}`;
        link.dataset.targetId = id;

        tocLinks.push({ link, id });

        const li = document.createElement('li');
        li.appendChild(link);
        fragment.appendChild(li);
    });

    const ul = document.createElement('ul');
    ul.className = 'gh-toc-list';
    ul.appendChild(fragment);
    tocList.appendChild(ul);

    // Update active TOC link based on scroll position
    function updateActiveLink() {
        const threshold = 50; // px from top of viewport
        let activeId = null;

        for (let i = 0; i < headings.length; i++) {
            const heading = headings[i];
            const rect = heading.getBoundingClientRect();
            // Last heading that has passed the threshold is the current section
            if (rect.top <= threshold) {
                activeId = heading.id;
            }
        }
        if (!activeId && headings.length > 0) {
            activeId = headings[0].id;
        }

        tocLinks.forEach((item) => {
            item.link.classList.toggle('is-active', item.id === activeId);
        });
    }

    updateActiveLink();
    window.addEventListener('scroll', updateActiveLink, { passive: true });
}
